export const ASSET_SHARED_GET_DATA = 'ASSET_SHARED_GET_DATA'
export const ASSET_SHARED_GET_DATA_SUCCESS = 'ASSET_SHARED_GET_DATA_SUCCESS'
export const ASSET_SHARED_GET_DATA_FAILURE = 'ASSET_SHARED_GET_DATA_FAILURE'
export const ASSET_SHARED_EMPTY = 'ASSET_SHARED_EMPTY'

export const SHARE_ASSET = 'SHARE_ASSET'
export const SHARE_ASSET_SUCCESS = 'SHARE_ASSET_SUCCESS'
export const SHARE_ASSET_FAILURE = 'SHARE_ASSET_FAILURE'

export const ASSET_SHARED_SET_SELECT = 'ASSET_SHARED_SET_SELECT'
export const ASSET_SHARED_UNSET_SELECT = 'ASSET_SHARED_UNSET_SELECT'

export const ASSET_SHARED_ACTIVEVIEW = 'ASSET_SHARED_ACTIVEVIEW'

export const ASSET_SHARED_EDIT_SELECT = 'ASSET_SHARED_EDIT_SELECT'
export const ASSET_SHARED_EDIT_UNSET_SELECT = 'ASSET_SHARED_EDIT_UNSET_SELECT'
export const ASSET_SHARED_EDIT = 'ASSET_SHARED_EDIT'
export const ASSET_SHARED_EDIT_SUCCESS = 'ASSET_SHARED_EDIT_SUCCESS'
export const ASSET_SHARED_EDIT_FAILURE = 'ASSET_SHARED_EDIT_FAILURE'

export const ASSET_SHARED_DELETE = 'ASSET_SHARED_DELETE'
export const ASSET_SHARED_DELETE_SUCCESS = 'ASSET_SHARED_DELETE_SUCCESS'
export const ASSET_SHARED_DELETE_FAILURE = 'ASSET_SHARED_DELETE_FAILURE'

export const ASSET_SHARED_EXPAND_SELECT = 'ASSET_SHARED_EXPAND_SELECT'
export const ASSET_SHARED_EXPAND_UNSET_SELECT = 'ASSET_SHARED_EXPAND_UNSET_SELECT'

export const ASSET_SHARED_SHARE_SELECT = 'ASSET_SHARED_SHARE_SELECT'
export const ASSET_SHARED_SHARE_UNSET_SELECT = 'ASSET_SHARED_SHARE_UNSET_SELECT'

export const ASSET_SHARED_MOVE = 'ASSET_SHARED_MOVE'
export const ASSET_SHARED_MOVE_SUCCESS = 'ASSET_SHARED_MOVE_SUCCESS'
export const ASSET_SHARED_MOVE_FAILURE = 'ASSET_SHARED_MOVE_FAILURE'

export const ASSET_SHARED_CHECK_SELECT = 'ASSET_SHARED_CHECK_SELECT'
export const ASSET_SHARED_UNCHECK_SELECT = 'ASSET_SHARED_UNCHECK_SELECT'

export const MULTIPLE_SHARED_OPTIONS_ACTIVATE = 'MULTIPLE_SHARED_OPTIONS_ACTIVATE'
export const MULTIPLE_SHARED_OPTIONS_DEACTIVATE = 'MULTIPLE_SHARED_OPTIONS_DEACTIVATE'
export const MULTIPLE_SHARED_OPTIONS_DONE = 'MULTIPLE_SHARED_OPTIONS_DONE'


export const SHARE_LINK_ASSET = 'SHARE_LINK_ASSET'
export const SHARE_LINK__ASSET_SUCCESS = 'SHARE_LINK__ASSET_SUCCESS'
export const SHARE_LINK__ASSET_FAILURE = 'SHARE_LINK__ASSET_FAILURE'

export const ASSET_SHARED_UPDATE_FROM_PERMISSION = 'ASSET_SHARED_UPDATE_FROM_PERMISSION'

export const ASSETS_SHARED_MULTI_DELETE = 'ASSETS_SHARED_MULTI_DELETE'
export const ASSETS_SHARED_MULTI_DELETE_SUCCESS = 'ASSETS_SHARED_MULTI_DELETE_SUCCESS'
export const ASSETS_SHARED_MULTI_DELETE_FAILURE = 'ASSETS_SHARED_MULTI_DELETE_FAILURE'

export const ASSETS_SHARED_MULTI_MOVE = 'ASSETS_SHARED_MULTI_MOVE'
export const ASSETS_SHARED_MULTI_MOVE_SUCCESS = 'ASSETS_SHARED_MULTI_MOVE_SUCCESS'
export const ASSETS_SHARED_MULTI_MOVE_FAILURE = 'ASSETS_SHARED_MULTI_MOVE_FAILURE'